import script from "./BetaHomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./BetaHomeView.vue?vue&type=script&setup=true&lang=js"

import "./BetaHomeView.vue?vue&type=style&index=0&id=2662cac4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2662cac4"]])

export default __exports__